var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h2", [
      _vm._v(_vm._s(_vm.t("health", "Welcome to your health center")))
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-2" }, [
        _c("textarea", {
          ref: "mission",
          staticClass: "textarea-mission",
          domProps: { value: _vm.person.personalMission }
        }),
        _vm._v(" "),
        _c("button", { on: { click: _vm.updateMission } }, [
          _vm._v("\n\t\t\t\t" + _vm._s(_vm.t("health", "Save ")) + "\n\t\t\t")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-2" }, [
        _c("p", [
          _vm._v(
            _vm._s(
              _vm.t(
                "health",
                "You can start here with giving you yourself a personal mission. Maybe you have a special target, a medical specification or a bet with your friends or partner. It could help you to describe it here. Giving yourself a bounty if you reach the targets or think about an emergency plan, if the things getting worth is also a good idea..."
              )
            )
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }